import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useHttpFetch from "../hooks/useHttpFetch";
import { useContext, useEffect } from "react";
import AdminAuthContext from "../store/adminStore/admin-auth-context";
import { toast } from "react-toastify";
import LoadingOverLoadedPage from "../Components/UI/LoadingOverLoadedPage/LoadingOverLoadedPage";
import classes from "./IsLoggedInInERP.module.css";
import readPackageAccessResFromIndexedDB from "../utils/cache/PackageAccess/readPackageAccessResFromIndexedDB";
import clearERPStores from "../utils/cache/clearERPStores";
import storePackageAccessResInIndexedDB from "../utils/cache/PackageAccess/storePackageAccessResInIndexedDB";

const IsLoggedInInERP = () => {
  const { error, sendRequest } = useHttpFetch();
  const { setClientAuthInfo, clientAuthInfo } = useContext(AdminAuthContext);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const getPackageAccessViaApi = async () => {
      const verifyReqOptions = {
        url: `PackageAccess`,
        noMiddleUrl: true,
      };

      const authRes = await sendRequest(verifyReqOptions);

      if (authRes?.resIsOk) {
        setClientAuthInfo((ps) => ({
          ...ps,
          isLoggedIn: true,
          accessibilities: authRes.response.packageAccesses,
          firstName: authRes.response?.firstName,
          lastName: authRes.response?.lastName,
          userId: authRes.response?.userId,
          baseUserId: authRes.response?.baseUserId,
          userTypeEnum: authRes.response?.userTypeEnum,
          organizationalTitles: authRes.response?.organizationalTitles,
        }));
        if (location.pathname?.includes("login")) navigate("/admin-home-page");
        const preferedData = {
          isLoggedIn: true,
          accessibilities: authRes.response.packageAccesses,
          firstName: authRes.response?.firstName,
          lastName: authRes.response?.lastName,
          userTypeEnum: authRes.response?.userTypeEnum,
          organizationalTitles: authRes.response?.organizationalTitles,
          baseUserId: authRes.response?.baseUserId,
          userId: authRes.response?.userId,
        };
        await storePackageAccessResInIndexedDB(preferedData);
      } else {
        const authResp = await sendRequest({
          url: `panel/AccessToken`,
          noMiddleUrl: true,
          port: "8088",
        });
        if (authResp.resIsOk) {
          const authenticateReqOptions = {
            url: "UserAuthenticate?calendar=pe&language=persian",
            additionalHeader: { Authorization: `Bearer ${authResp.response.message}` },
            noMiddleUrl: true,
          };
          const authRes = await sendRequest(authenticateReqOptions);
          if (authRes.resIsOk) {
            setClientAuthInfo((ps) => ({
              ...ps,
              isLoggedIn: true,
              accessibilities: authRes.response.packageAccesses,
              firstName: authRes.response?.firstName,
              lastName: authRes.response?.lastName,
              userId: authRes.response?.userId,
              baseUserId: authRes.response?.baseUserId,
              userTypeEnum: authRes.response?.userTypeEnum,
              organizationalTitles: authRes.response?.organizationalTitles,
            }));
            toast.success("logged in successfullys");
            if (location.pathname?.includes("login")) navigate("/admin-home-page");
            const preferedData = {
              isLoggedIn: true,
              accessibilities: authRes.response.packageAccesses,
              firstName: authRes.response?.firstName,
              lastName: authRes.response?.lastName,
              userTypeEnum: authRes.response?.userTypeEnum,
              organizationalTitles: authRes.response?.organizationalTitles,
              baseUserId: authRes.response?.baseUserId,
              userId: authRes.response?.userId,
            };
            await storePackageAccessResInIndexedDB(preferedData);
          } else {
            toast.error("error ::: ", authRes);
            clearERPStores();
            navigate("/admin/login");
          }
        } else {
          clearERPStores();
          navigate("/admin/login");
        }
      }
    };

    const findPackageAccessOnLoad = async () => {
      const indexedDBRes = await readPackageAccessResFromIndexedDB();

      if (indexedDBRes?.isLoggedIn) {
        setClientAuthInfo((ps) => ({
          ...ps,
          ...indexedDBRes,
        }));
        if (location.pathname?.includes("login")) navigate("/admin-home-page");
      } else {
        await getPackageAccessViaApi();
      }
      setClientAuthInfo((ps) => ({
        ...ps,
        isLoading: false,
      }));
    };
    findPackageAccessOnLoad();
    // getPackageAccessViaApi();
  }, []);

  return !clientAuthInfo.isLoading ? (
    <Outlet />
  ) : (
    <>
      <div className={classes.vpnTxt}>لطفا VPN خود را خاموش کنید</div>
      <div>
        <LoadingOverLoadedPage />
      </div>
    </>
  );
};

export default IsLoggedInInERP;
